
  (function(){
    var doc = document;
    var bar = doc.querySelector('[data-brf-sticky]');
    var info = doc.querySelector('.product-block-list__item--info');
    var mainBtn = info && info.querySelector('.product-form__add-button');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
    var form = mainBtn.closest('form') || info;
    /* Warehouse 7 redraws the price, variant picker and Add to bag button on variant change: look them up fresh */
    var mainBtn0 = mainBtn;
    function MB(){ return info.querySelector('.product-form__add-button') || mainBtn0; }
    function ID(){ return (form.querySelector('[name="id"]') || {}).value; }
    var idEl = form.querySelector('[name="id"]');
    var priceSlot = bar.querySelector('[data-brf-sticky-price]');
    var btn = bar.querySelector('[data-brf-sticky-btn]');
    var stepAt = 0;
    var thumb = bar.querySelector('[data-brf-sab-top]');
    var opts = bar.querySelector('[data-brf-sab-opts]');
    var priceList = info.querySelector('.product-form__info-content .price-list');
    var imgs = {}; try { imgs = JSON.parse((doc.querySelector('[data-brf-sab-img]') || {}).textContent || '{}'); } catch (e) {}
    var phone = window.matchMedia('(max-width: 767px)');
    var CHEV = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

    /* ---- the option groups on the page (radios or a dropdown) ---- */
    function groups(){
      return [].slice.call(form.querySelectorAll('.product-form__option[data-selector-type]')).map(function(g, pos){
        var nameEl = g.querySelector('.product-form__option-name');
        var name = nameEl ? (nameEl.childNodes[0] ? nameEl.childNodes[0].textContent : nameEl.textContent).replace(/:\s*$/, '').trim() : 'Option';
        var sel = g.querySelector('select'), values = [];
        if (sel) {
          [].forEach.call(sel.options, function(o){ values.push({v: o.getAttribute('data-value') || o.value, label: o.textContent.trim(), on: o.selected, pick: function(){ sel.value = o.value; sel.dispatchEvent(new Event('change', {bubbles: true})); }}); });
        } else {
          [].forEach.call(g.querySelectorAll('input[type="radio"]'), function(r){
            var lab = r.id ? form.querySelector('label[for="' + r.id + '"]') : null;
            var rv = r.getAttribute('data-value') || r.value; values.push({v: rv, label: rv, on: r.checked, lab: lab, pick: function(){ if (!r.checked) r.click(); }});
          });
        }
        return {el: g, pos: pos, name: name, type: g.getAttribute('data-selector-type'), values: values};
      }).filter(function(g){ return g.values.length > 1; });
    }
    /* a plain, standard colour dot worked out from the colour's name (not the fabric's own swatch photo) */
    var COLS = {black:'#111111',jet:'#111111',white:'#FFFFFF','off white':'#F4F1E8',ivory:'#FFFFF0',cream:'#F3E9D2',beige:'#E3D3B4',nude:'#E3BC9A',sand:'#D8C3A0',stone:'#C9BFAE',taupe:'#8B7D6B',camel:'#C19A6B',tan:'#D2B48C',
      khaki:'#B9A66B',brown:'#7B4A2A',chocolate:'#5A3218',coffee:'#6F4E37',mocha:'#7B5B47',rust:'#B7410E',copper:'#B87333',bronze:'#A97142',gold:'#D4AF37',mustard:'#D9A51E',lemon:'#FFF44F',yellow:'#F7D21E',
      orange:'#F28C28',peach:'#F7B89A',coral:'#F27B6B',salmon:'#F59A8A',red:'#D32F2A',scarlet:'#E3241B',cherry:'#C2182B',wine:'#722F37',burgundy:'#800020',maroon:'#7A1F2B',claret:'#7F1734',
      pink:'#F4A6C1','baby pink':'#F8C8DC','light pink':'#F8C8DC','hot pink':'#FF4FA0','dusty pink':'#D8A1A8',blush:'#F2C6C2',rose:'#E8A0B0',cerise:'#DE3163',fuchsia:'#E0218A',magenta:'#D0167E',
      lilac:'#C8A2C8',lavender:'#B9A7E0',mauve:'#B784A7',purple:'#6A3FA0',plum:'#6E2C5E',violet:'#7F4FC9',aubergine:'#472C4C',
      blue:'#2F6FD0','royal blue':'#2851C7','royal':'#2851C7',navy:'#1F2A57','navy blue':'#1F2A57','baby blue':'#A9CCEB','light blue':'#A9CCEB','sky blue':'#7EC3EA',sky:'#7EC3EA',cobalt:'#1F4FB5',denim:'#4A6A94',
      petrol:'#1F5F6B',teal:'#16808A',turquoise:'#2EC4C6',aqua:'#5FD4D6',jade:'#2F9C78',mint:'#A8E6C8',sage:'#A3B49A',
      green:'#2E9A55','bottle green':'#0F4D2E','dark green':'#1E5631',emerald:'#0E8A5A',lime:'#A6D93A',olive:'#6E7F2E','forest green':'#24502F',forest:'#24502F',
      grey:'#9A9A9A',gray:'#9A9A9A','light grey':'#C9C9C9','dark grey':'#555555',silver:'#C0C0C0',charcoal:'#36454F',slate:'#6D7B87'};
    var COLKEYS = Object.keys(COLS).sort(function(a, b){ return b.length - a.length; });
    var MULTI = 'background:conic-gradient(#E34B4B,#F2B33D,#4CB15F,#3E7DD6,#9B5BD3,#E34B4B)';
    function stdColour(name){
      var n = ' ' + String(name).toLowerCase().replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ') + ' ';
      if (/ (multi|multicolou?r|rainbow|mixed|assorted) /.test(n)) return MULTI;
      for (var i = 0; i < COLKEYS.length; i++) if (n.indexOf(' ' + COLKEYS[i] + ' ') > -1) return 'background:' + COLS[COLKEYS[i]];
      return MULTI;
    }
    function isColour(g){ return g.type === 'color' || g.type === 'variant' || /colou?r/i.test(g.name); }
    function swatchStyle(val){ return stdColour(val.label); }
    function isSwatch(g){ return isColour(g); }

    /* sold out? (with the other options as currently chosen) */
    var vars = []; try { vars = JSON.parse((doc.querySelector('[data-brf-sab-vars]') || {}).textContent || '[]'); } catch (e) {}
    function soldOut(gs, g, val){
      if (!vars.length) return false;
      var picks = {};
      gs.forEach(function(o){ if (o !== g) { var s = o.values.filter(function(v){ return v.on; })[0]; if (s) picks[o.pos] = s.v; } });
      return !vars.some(function(x){
        if (!x.a || x.o[g.pos] !== val.v) return false;
        for (var q in picks) if (x.o[q] !== picks[q]) return false;
        return true;
      });
    }
    /* R9. stock for the variant a value would give (with the other options as chosen); null = not tracked */
    function stockFor(gs, g, val){
      var picks = {};
      gs.forEach(function(o){ if (o !== g) { var s2 = o.values.filter(function(v){ return v.on; })[0]; if (s2) picks[o.pos] = s2.v; } });
      picks[g.pos] = val.v;
      var hit = vars.filter(function(x){ for (var q in picks) if (x.o[q] !== picks[q]) return false; return true; })[0];
      return hit && hit.i ? stockOf(String(hit.i)) : null;
    }
    function stockLabel(n){ return n <= 0 ? 'Sold out' : n <= 5 ? 'Only ' + n + ' left' : n + ' in stock'; }
    function badge(gs, g, v){
      if (soldOut(gs, g, v)) return '<em>Sold out</em>';
      var n = stockFor(gs, g, v);
      return n == null ? '' : '<em class="brf-sab-q' + (n <= 5 ? ' is-low' : '') + '">' + stockLabel(n) + '</em>';
    }

    var lastSig = '';
    function paintOpts(){
      var gs = groups();
      var show = gs.slice(0, phone.matches ? 1 : 3);
      bar.classList.toggle('has-opts', gs.length > 0);
      var sig = show.map(function(g){ var s = g.values.filter(function(v){ return v.on; })[0]; return g.name + '=' + (s ? s.v : ''); }).join('|') + '|' + window.innerWidth;
      if (sig === lastSig) return; lastSig = sig;
      opts.innerHTML = show.map(function(g, i){
        var s = g.values.filter(function(v){ return v.on; })[0];
        var dot = isSwatch(g) && s ? swatchStyle(s) : '';
        var more = gs.length > show.length && i === show.length - 1 ? '<em class="brf-sab__more">+' + (gs.length - show.length) + '</em>' : '';
        return '<button type="button" class="brf-sab__seg" data-i="' + i + '" aria-haspopup="dialog" title="' + esc(g.name) + '" aria-label="Change ' + esc(g.name) + ', now ' + esc(s ? s.label : 'not chosen') + '">' +
          (dot ? '<i class="brf-sab__dot" style="' + esc(dot) + '"></i>' : '') + '<span>' + esc(s ? s.label : 'Choose ' + g.name) + '</span>' + more + CHEV + '</button>';
      }).join('');
    }

    /* ---- the sheet that opens from a segment ---- */
    var scrim = null, sheet = null;
    function closeSheet(){
      if (!sheet) return;
      var s = sheet, sc = scrim; sheet = scrim = null;
      s.classList.remove('is-on'); sc.classList.remove('is-on');
      setTimeout(function(){ s.remove(); sc.remove(); }, 380);
    }
    function openSheet(i){
      var gs = groups(); if (!gs[i]) return;
      closeSheet();
      scrim = doc.createElement('div'); scrim.className = 'brf-sab-scrim';
      sheet = doc.createElement('div'); sheet.className = 'brf-sab-sheet'; sheet.setAttribute('role', 'dialog');
      var title = gs.length > 1 ? 'Choose your options' : 'Choose ' + gs[0].name.toLowerCase();
      sheet.setAttribute('aria-label', title);
      var html = '<div class="brf-sab-sheet__grab"></div><div class="brf-sab-sheet__h"><span>' + esc(title) + '</span><button type="button" class="brf-sab-sheet__x" aria-label="Close">&times;</button></div><div class="brf-sab-sheet__body">';
      gs.forEach(function(g, gi){
        var sw = isSwatch(g), cur = g.values.filter(function(v){ return v.on; })[0];
        /* R10. colours are swatches only (the name shows on hover, or on tap on phones) so the stock line has room */
        html += (gs.length > 1 || sw ? '<p class="brf-sab-sheet__g" data-g="' + gi + '">' + esc(g.name) + (sw ? ' <b data-sel>' + esc(cur ? cur.label : '') + '</b>' : '') + '</p>' : '') +
          '<div class="brf-sab-sheet__list' + (sw ? ' is-sw' : '') + '" data-g="' + gi + '">' + g.values.map(function(v, k){
          var dot = sw ? swatchStyle(v) : '', oos = soldOut(gs, g, v);
          return '<button type="button" class="brf-sab-sheet__o' + (sw ? ' is-sw' : '') + (v.on ? ' is-sel' : '') + (oos ? ' is-oos' : '') + '" data-k="' + k + '" data-name="' + esc(v.label) + '" aria-pressed="' + v.on + '" aria-label="' + esc(v.label) + (oos ? ', sold out' : '') + '">' +
            (dot ? '<i class="brf-sab__dot" style="' + esc(dot) + '"></i>' : '') + (sw ? '' : '<span>' + esc(v.label) + '</span>') + badge(gs, g, v) + '</button>';
        }).join('') + '</div>';
      });
      sheet.innerHTML = html + '</div>';
      doc.body.appendChild(scrim); doc.body.appendChild(sheet);
      addPane();
      requestAnimationFrame(function(){ scrim.classList.add('is-on'); sheet.classList.add('is-on'); });
      var target = sheet.querySelector('.brf-sab-sheet__g[data-g="' + i + '"]');
      if (target && i > 0) setTimeout(function(){ var body = sheet && sheet.querySelector('.brf-sab-sheet__body'); if (body) body.scrollTop = target.offsetTop - body.offsetTop - 4; }, 30);
      scrim.addEventListener('click', closeSheet);
      sheet.querySelector('.brf-sab-sheet__x').addEventListener('click', closeSheet);
      sheet.addEventListener('click', function(e){
        var o = e.target.closest('.brf-sab-sheet__o'); if (!o) return;
        var list = o.parentNode, g = groups()[+list.getAttribute('data-g')]; if (!g) return;
        var v = g.values[+o.getAttribute('data-k')]; if (!v) return;
        [].forEach.call(list.querySelectorAll('.brf-sab-sheet__o'), function(x){ x.classList.toggle('is-sel', x === o); x.setAttribute('aria-pressed', x === o); });
        v.pick();
        if (o.classList.contains('is-sw')) {
          [].forEach.call(list.querySelectorAll('.is-tip'), function(x){ x.classList.remove('is-tip'); });
          o.classList.add('is-tip'); clearTimeout(o.__tipT); o.__tipT = setTimeout(function(){ o.classList.remove('is-tip'); }, 1600);
          var hd = sheet.querySelector('.brf-sab-sheet__g[data-g="' + list.getAttribute('data-g') + '"] [data-sel]'); if (hd) hd.textContent = v.label;
        }
        setTimeout(function(){
          sync(); paneCurrent();
          if (gs.length === 1) { closeSheet(); return; }
          var now = groups();
          [].forEach.call(sheet ? sheet.querySelectorAll('.brf-sab-sheet__list') : [], function(l){
            var gg = now[+l.getAttribute('data-g')]; if (!gg) return;
            [].forEach.call(l.querySelectorAll('.brf-sab-sheet__o'), function(b){
              var vv = gg.values[+b.getAttribute('data-k')]; if (!vv) return;
              var oos = soldOut(now, gg, vv); b.classList.toggle('is-oos', oos);
              var em = b.querySelector('em'); if (em) em.remove(); b.insertAdjacentHTML('beforeend', badge(now, gg, vv));
            });
          });
        }, 220);
      });
      var first = sheet.querySelector('[data-g="' + i + '"] .is-sel') || sheet.querySelector('.brf-sab-sheet__o'); if (first) setTimeout(function(){ try { first.focus({preventScroll: true}); } catch (e) {} }, 60);
    }
    opts.addEventListener('click', function(e){ var s = e.target.closest('.brf-sab__seg'); if (s) openSheet(+s.getAttribute('data-i')); });
    doc.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSheet(); });
    thumb.addEventListener('click', function(){
      var g = doc.querySelector('.product-gallery') || doc.querySelector('.product-block-list__item--gallery');
      if (g) g.scrollIntoView({behavior: 'smooth', block: 'start'}); else window.scrollTo({top: 0, behavior: 'smooth'});
    });

    /* ---- 2026-10-26 (Abid): desktop "living photo". The card shows the chosen colour's photo; hovering it lifts a large
       peek above the card; and in the colour sheet, hovering a swatch previews that colour's photo before you pick it. ---- */
    function varFor(gs, g, val){
      var picks = {};
      gs.forEach(function(o){ if (o !== g) { var s2 = o.values.filter(function(v){ return v.on; })[0]; if (s2) picks[o.pos] = s2.v; } });
      picks[g.pos] = val.v;
      return vars.filter(function(x){ for (var q in picks) if (x.o[q] !== picks[q]) return false; return true; })[0] || null;
    }
    function curLabel(){
      return groups().map(function(g){ var s = g.values.filter(function(v){ return v.on; })[0]; return s ? s.label : ''; }).filter(Boolean).join(' \u00b7 ');
    }
    function curSrc(){ var id = ID(), im = thumb.querySelector('img'); return (id && imgs[id]) || (im && im.getAttribute('src')) || ''; }
    var peek = doc.createElement('div'); peek.className = 'brf-sab__peek'; peek.setAttribute('aria-hidden', 'true');
    peek.innerHTML = '<img alt="" decoding="async"><span class="brf-sab__peek-cap"><b></b><small>Click the small thumbnail below to scroll back up to the product photos.<i class="brf-sab__peek-joke">No bull, it’s that easy 🐂</i></small></span>';
    (bar.querySelector('.brf-sab__bar') || bar).appendChild(peek);
    var peekImg = peek.querySelector('img'), peekCap = peek.querySelector('b'), peekT = 0;
    function peekFill(){ var src = curSrc(); if (src && peekImg.getAttribute('src') !== src) peekImg.src = src; peekCap.textContent = curLabel() || ((bar.querySelector('.brf-sab__title') || {}).textContent || '').trim(); }
    function showPeek(on){
      clearTimeout(peekT);
      if (on && !phone.matches && curSrc()) { peekFill(); peekT = setTimeout(function(){ bar.classList.add('is-peek'); }, 90); }
      else bar.classList.remove('is-peek');
    }
    thumb.addEventListener('mouseenter', function(){ showPeek(true); });
    thumb.addEventListener('mouseleave', function(){ showPeek(false); });
    thumb.addEventListener('focus', function(){ showPeek(true); });
    thumb.addEventListener('blur', function(){ showPeek(false); });
    /* colour sheet photo pane (desktop) */
    function paneSet(src, name, note){
      var pane = sheet && sheet.querySelector('.brf-sab-sheet__pane'); if (!pane) return;
      var im = pane.querySelector('img'), ph = pane.querySelector('.brf-sab-sheet__ph'), ps = pane.querySelector('.brf-sab-sheet__ps');
      if (src && im.getAttribute('src') !== src) { im.src = src; ph.classList.remove('is-swap'); void ph.offsetWidth; ph.classList.add('is-swap'); }
      pane.querySelector('.brf-sab-sheet__pn').textContent = name || '';
      ps.textContent = note || ''; ps.classList.toggle('is-low', /sold|only/i.test(note || ''));
    }
    function paneCurrent(){ var id = ID(), n = id ? stockOf(id) : null; paneSet(curSrc(), curLabel(), MB().disabled ? 'Sold out' : n == null ? '' : stockLabel(n)); }
    var warmed = false;
    function warm(){
      if (warmed) return; warmed = true;
      var seen2 = {}; Object.keys(imgs).forEach(function(k){ var u = imgs[k]; if (u && !seen2[u]) { seen2[u] = 1; var i = new Image(); i.decoding = 'async'; i.src = u; } });
    }
    function addPane(){
      if (!sheet || phone.matches || !curSrc() || sheet.querySelector('.brf-sab-sheet__pane')) return;
      warm();
      sheet.classList.add('has-pane');
      var pane = doc.createElement('div'); pane.className = 'brf-sab-sheet__pane';
      pane.innerHTML = '<div class="brf-sab-sheet__ph"><img alt="" decoding="async"></div><p class="brf-sab-sheet__pn"></p><p class="brf-sab-sheet__ps"></p>';
      sheet.insertBefore(pane, sheet.querySelector('.brf-sab-sheet__body'));
      paneCurrent();
      var body = sheet.querySelector('.brf-sab-sheet__body');
      body.addEventListener('mouseover', function(e){
        var o = e.target.closest && e.target.closest('.brf-sab-sheet__o'); if (!o) return;
        var gs2 = groups(), g = gs2[+o.parentNode.getAttribute('data-g')]; if (!g) return;
        var v = g.values[+o.getAttribute('data-k')]; if (!v) return;
        var hit = varFor(gs2, g, v), n = hit ? stockOf(String(hit.i)) : null;
        paneSet((hit && imgs[hit.i]) || curSrc(), v.label, hit && !hit.a ? 'Sold out' : n == null ? '' : stockLabel(n));
      });
      body.addEventListener('mouseleave', paneCurrent);
    }

    /* ---- keep everything in step with the page ---- */
    var lastId = null, addedUntil = 0, pendingAt = 0;
    function sync(){
      var pl0 = info.querySelector('.product-form__info-content .price-list') || priceList; var p = pl0 ? pl0.querySelector('.price') : null;
      priceSlot.textContent = p ? p.textContent.trim() : '';
      btn.disabled = !!MB().disabled;
      var lbl = btn.querySelector('.brf-sab__lbl');
      var done = Date.now() < addedUntil;
      btn.classList.toggle('brf-added', done);
      if (lbl) {
        var t = done ? 'Added to bag' : MB().disabled ? (MB().textContent.trim() || 'Sold out') : 'Add to bag';
        if (lbl.textContent !== t) lbl.textContent = t;
        lbl.classList.toggle('is-added', done);
      }
      var id = ID();
      var sEl = bar.querySelector('[data-brf-sab-stock]');
      if (sEl) {
        var n = id ? stockOf(id) : null;
        var t2 = MB().disabled ? '' : n == null ? 'In stock' : stockLabel(n);
        if (sEl.textContent !== t2) sEl.textContent = t2;
        sEl.hidden = !t2;
        sEl.classList.toggle('is-low', n != null && n <= 5);
      }
      if (id && id !== lastId) {
        var src = imgs[id];
        var im = thumb.querySelector('img');
        if (src && im && im.getAttribute('src') !== src) {
          im.src = src; thumb.classList.remove('is-swap'); void thumb.offsetWidth; thumb.classList.add('is-swap');
          if (bar.classList.contains('is-peek')) peekFill();
        }
        lastId = id;
      }
      paintOpts();
    }
    sync();
    setInterval(function(){ if (!doc.hidden) sync(); }, 400);
    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      if (priceList) mo.observe(priceList, {childList: true, subtree: true, characterData: true});
      mo.observe(mainBtn, {attributes: true, attributeFilter: ['disabled', 'class']});
    }
    form.addEventListener('change', function(){ setTimeout(sync, 30); });
    window.addEventListener('resize', function(){ lastSig = ''; paintOpts(); }, {passive: true});

    /* The bar floats whenever the real button is off screen (above or below), so Add to bag is always one tap away.
       2026-10-26 (Abid): desktop too (it used to wait until you'd scrolled past the button); it vanishes once the real button is in view. */
    /* 2026-10-26 (Abid): the card also steps aside while the page's own Length / Quantity box is on screen, so there is never a
       second quantity box in view. As it slips away, the page's box and the Add to bag beside it glow briefly, like the card handing over to it. */
    var seen = [], wasOn = null;
    /* the quantity row counts only while it has its own Add to bag beside it (brf-pdp-fab, big screens); on phones the card stays */
    function QR(){ var r = info.querySelector('.product-form__info-item--quantity'), f = r && r.querySelector('.brf-fab'); return f && f.offsetParent ? r : null; }
    function decide(){
      var on = !seen.some(function(x){ return x.on; });
      bar.hidden = false;
      bar.classList.toggle('is-visible', on);
      doc.body.classList.toggle('brf-sticky-on', on);
      if (!on) { closeSheet(); bar.classList.remove('is-peek'); }
      if (wasOn === true && !on) {
        var q = QR(), qr = q && q.getBoundingClientRect();
        if (qr && qr.bottom > 0 && qr.top < window.innerHeight) { q.classList.remove('brf-handoff'); void q.offsetWidth; q.classList.add('brf-handoff'); setTimeout(function(){ q.classList.remove('brf-handoff'); }, 1400); }
      }
      wasOn = on;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ seen.forEach(function(x){ if (x.el === e.target) x.on = e.isIntersecting; }); });
      decide();
    }, {threshold: 0});
    function watch(el){
      if (!el || seen.some(function(x){ return x.el === el; })) return;
      var r = el.getBoundingClientRect();
      seen.push({el: el, on: r.bottom > 0 && r.top < window.innerHeight && (r.width > 0 || r.height > 0)}); io.observe(el);
    }
    function rewatch(){
      var want = [MB(), QR()].filter(Boolean), changed = false;
      seen = seen.filter(function(x){ if (want.indexOf(x.el) > -1 && x.el.isConnected) return true; try { io.unobserve(x.el); } catch (e) {} changed = true; return false; });
      want.forEach(function(el){ if (!seen.some(function(x){ return x.el === el; })) { watch(el); changed = true; } });
      if (changed) decide();
    }
    watch(mainBtn); watch(QR());
    /* desktop: the card sits under the product details column, clear of the chat button in the corner */
    function placeBar(){
      if (phone.matches) { bar.style.removeProperty('--brf-sab-l'); bar.style.removeProperty('--brf-sab-w'); return; }
      var r = info.getBoundingClientRect(); if (!r.width) return;
      var w = Math.min(r.width, 560), l = r.left + (r.width - w) / 2;
      l = Math.max(16, Math.min(l, window.innerWidth - 96 - w));
      bar.style.setProperty('--brf-sab-l', Math.round(l) + 'px'); bar.style.setProperty('--brf-sab-w', Math.round(w) + 'px');
    }
    placeBar(); window.addEventListener('resize', placeBar, {passive: true}); window.addEventListener('load', placeBar);
    setInterval(rewatch, 500);
    /* ---- quantity box: kept in step with the page's own quantity (select 1–10+, or a box after "10+") ---- */
    var qWrap = bar.querySelector('[data-brf-sab-qty]'), qIn = qWrap && qWrap.querySelector('.brf-sab__in');
    /* stock per variant (brf-v3 prints it further down the page, so read it when needed), less what's already in the bag */
    var stock = null, inBag = {};
    function stockOf(id){
      if (!stock) { var el = doc.getElementById('brf-v3-stock'); if (el) { try { stock = JSON.parse(el.textContent || '{}'); } catch (e) { stock = {}; } } }
      return stock ? stock[id] : null;
    }
    function loadBag(){
      fetch('/cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
        inBag = {}; (c.items || []).forEach(function(it){ inBag[it.variant_id] = (inBag[it.variant_id] || 0) + it.quantity; });
        if (qIn) setBarQ(parseInt(qIn.value, 10) || 1);
      }).catch(function(){});
    }
    function mainQ(){ return form.querySelector('[name="quantity"]'); }
    function capQ(){
      var id = ID(), m = stockOf(id);
      if (m == null) return 999;
      return Math.max(1, m - (inBag[id] || 0));
    }
    function leftNow(){ var id = ID(), m = stockOf(id); return m == null ? null : Math.max(0, m - (inBag[id] || 0)); }
    var tip = null, tipT = 0;
    function capTip(){
      var n = leftNow(); if (n == null || !qWrap) return;
      var barEl = bar.querySelector('.brf-sab__bar');
      if (!tip) { tip = doc.createElement('div'); tip.className = 'brf-sab__tip'; tip.setAttribute('role', 'status'); barEl.appendChild(tip); }
      var qr = qWrap.getBoundingClientRect(), br = barEl.getBoundingClientRect();
      tip.style.setProperty('--ax', Math.round(qr.left + qr.width / 2 - br.left) + 'px');
      var had = inBag[ID()] || 0;
      tip.textContent = n <= 0 ? 'That\u2019s all we have \u2013 it\u2019s in your bag!'
        : had ? 'Just ' + n + ' more \u2013 you\u2019ve ' + had + ' in your bag already!'
        : (n === 1 ? 'Only 1 left \u2013 it\u2019s all yours!' : 'Only ' + n + ' left \u2013 that\u2019s the lot!');
      tip.classList.remove('is-on'); void tip.offsetWidth; tip.classList.add('is-on');
      qWrap.classList.remove('is-max'); void qWrap.offsetWidth; qWrap.classList.add('is-max');
      clearTimeout(tipT); tipT = setTimeout(function(){ tip.classList.remove('is-on'); qWrap.classList.remove('is-max'); }, 2600);
    }
    function getMain(){ var q = mainQ(); return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1; }
    /* R9. Only touch the page's quantity when the number really differs, never re-trigger ourselves,
       and never leave the page's box focused (that popped the phone keyboard up on its own). */
    var syncing = false;
    function fire(el, type){ syncing = true; try { el.dispatchEvent(new Event(type, {bubbles: true})); } finally { syncing = false; } }
    function setMain(v){
      var q = mainQ(); if (!q || String(q.value) === String(v)) return;
      if (q.tagName === 'SELECT') {
        var has = [].some.call(q.options, function(o){ return o.value === String(v) && o.textContent.indexOf('+') < 0; });
        if (has) { q.value = String(v); fire(q, 'change'); return; }
        /* more than the list holds: pick "10+" so the theme swaps in its own box, then fill it */
        if (![].some.call(q.options, function(o){ return o.value === '10'; })) return;
        var had = doc.activeElement;
        q.value = '10'; fire(q, 'change'); q = mainQ();
        if (q && doc.activeElement === q && had !== q) { q.blur(); if (had === qIn) try { qIn.focus({preventScroll: true}); } catch (e) {} }
        if (!q || q.tagName === 'SELECT') return;
      }
      q.value = String(v); fire(q, 'input');
    }
    var lastMainQ = getMain();
    function paintQ(){
      if (!qIn) return;
      var cap = capQ(), v = Math.min(Math.max(1, parseInt(qIn.value, 10) || 1), cap);
      qWrap.querySelector('[data-d="-1"]').disabled = v <= 1;
      qWrap.querySelector('[data-d="1"]').classList.toggle('is-cap', v >= cap);
      return v;
    }
    function setBarQ(v, push){
      if (!qIn) return;
      v = Math.min(Math.max(1, v || 1), capQ());
      if (doc.activeElement !== qIn || push) qIn.value = String(v);
      paintQ();
      if (push) { setMain(v); lastMainQ = getMain(); }
    }
    if (qIn) {
      qWrap.addEventListener('click', function(e){
        var b = e.target.closest('.brf-sab__step'); if (!b) return;
        stepAt = Date.now();
        var cur = parseInt(qIn.value, 10) || 1, d = +b.getAttribute('data-d');
        if (d > 0 && cur >= capQ()) { capTip(); return; }
        if (b.disabled) return;
        setBarQ(cur + d, true);
        if (d > 0 && cur + d >= capQ() && leftNow() != null) capTip();
      });
      qIn.addEventListener('input', function(){ var v = parseInt(qIn.value, 10); if (v > 0) { if (v > capQ()) { qIn.value = String(capQ()); capTip(); } setMain(Math.min(v, capQ())); lastMainQ = getMain(); } paintQ(); });
      qIn.addEventListener('blur', function(){ setBarQ(parseInt(qIn.value, 10) || 1, true); });
      qIn.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); qIn.blur(); } });
      /* the page's quantity changed (or the variant's stock cap did): follow it */
      setInterval(function(){ if (doc.hidden || doc.activeElement === qIn) return; var m = getMain(); if (m !== lastMainQ) { lastMainQ = m; setBarQ(m); } else paintQ(); }, 400);
      setBarQ(lastMainQ);
      loadBag();
      window.addEventListener('product:added', function(){ setTimeout(loadBag, 400); }, true);
      doc.addEventListener('brf:bag-added-mobile', function(){ setTimeout(loadBag, 400); });
      /* the variant changed: re-check the cap */
      form.addEventListener('change', function(e){
        if (syncing || (e.target && e.target.name === 'quantity')) return;
        setTimeout(function(){ var v = parseInt(qIn.value, 10) || 1; if (v > capQ()) setBarQ(v, true); else paintQ(); }, 60);
      });
    }

    /* phones: a tap on Add right after − / + is a slipped finger, not a real add */
    btn.addEventListener('click', function(e){ if (phone.matches && Date.now() - stepAt < 450) { e.preventDefault(); e.stopImmediatePropagation(); } });
    btn.addEventListener('click', function(){
      if (MB().disabled) return;
      if (qIn) { if (leftNow() === 0) { capTip(); return; } setBarQ(parseInt(qIn.value, 10) || 1, true); }
      pendingAt = Date.now(); MB().click();
    });
    info.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.product-form__add-button')) pendingAt = Date.now(); });

    /* R7. The bar's button says "Added to bag ✓" for a moment after an add (phones and desktop) */
    function markAdded(){
      if (!pendingAt || Date.now() - pendingAt > 10000) return;
      pendingAt = 0; addedUntil = Date.now() + 2200;
      sync(); btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
      setTimeout(sync, 2250);
    }
    window.addEventListener('product:added', markAdded, true);
    doc.addEventListener('brf:bag-added-mobile', markAdded);
    /* fallback: the bag count goes up */
    var cnt = doc.querySelector('.header__cart-count');
    if (cnt && window.MutationObserver) {
      var lastN = parseInt(cnt.textContent, 10) || 0;
      new MutationObserver(function(){ var n = parseInt(cnt.textContent, 10) || 0; if (n > lastN) markAdded(); lastN = n; })
        .observe(cnt, {childList: true, characterData: true, subtree: true});
    }
  })();
  